module.exports = __webpack_public_path__ + "dist/assets/28bed118828913b813385214b01c2d8d.svg";